/**
 * The single responsive breakpoint this app targets - desktop above it, mobile at or
 * below it. Import from here rather than redeclaring it; there is no tablet size.
 */
export const MOBILE_BREAKPOINT = '768px';

/**
 *A extra large responsive breakpoint for desktop in specific situations like hiding a side bar.
 *Typically small desktop/laptop size. Import from here rather than redeclaring it; there
 * is no tablet size.
 */
export const XL_BREAKPOINT = '1200px';

/**
 * Ready-made media query key for a styled-component's mobile overrides.
 * Use as a computed key: `[MOBILE_MEDIA_QUERY]: { flexDirection: 'column' }`.
 */
export const MOBILE_MEDIA_QUERY = `@media (max-width: ${MOBILE_BREAKPOINT})`;
